import { takeLatest } from 'redux-saga/effects';

import { downloadMediaplan } from './downloadMediaplan';
import * as NS from '../../types';

const downloadMediaplanType: NS.DownloadMediaplan['type'] = 'DOWNLOAD_MEDIAPLAN_SERVICE:DOWNLOAD';

export function* rootSaga() {
  yield takeLatest(downloadMediaplanType, downloadMediaplan);
}
